<template>
  <v-card tile>
    <v-container style="min-height: 100vh; height: 100%">
      <v-card tile class="pa-3" height="100%">
        <iframe
          src="https://b2c.dev.anvio.com/ru/moscow/bookingwidget"
          width="100%"
          height="1000"
          frameborder="0"
        ></iframe>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "IframeTest",
};
</script>
